import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Row, Col, Button, Card } from "reactstrap";
import { DOG_DELETE_URL, DOG_LISTING_URL } from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import API from "../../../redux/actions/API";
import { getAgencyId } from "../../common/CommonFunctions";
import CreateNewDog from "./CreateNewDog";
import Swal from "sweetalert2";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import moment from "moment";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import dogImg from "../../../images/dog.png";

export default function MyDog(props) {
  const { userId } = props;
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [flag, setflag] = useState(true);
  const [details, setdetails] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [selectedDogId, setDogId] = useState();
  const Delete = useSelector((state) => state.Agencydelete);

  const toggle = () => {
    if (Delete) return;
    setModal(!modal);
    setDogId("");
    setflag(true);
  };
  const successCallBack = () => {
    setModal(false);
    dogDetails();
  };
  const dogDetails = async () => {
    const config = {
      method: "GET",
      url: DOG_LISTING_URL,
      headers: authHeader(),
      params: { userId: userId, agencyId: getAgencyId() },
    };
    try {
      const response = await API(config);
      const { data } = response.data;
      setdetails(data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    dogDetails();
  }, []);
  const deleteDogFun = async (dog_id) => {
    setLoading(true);
    const config = {
      method: "DELETE",
      url: DOG_DELETE_URL,
      headers: authHeader(),
      params: { dogId: dog_id },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        CustomAlertMessage(
          "Dog Details Deleted Successfully!",
          "success",
          enqueueSnackbar
        );

        dogDetails();
      }
    } catch (error) {
      console.error(error);
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };
  const deleteDog = (e) => {
    if (Delete) return;
    e.stopPropagation();
    let dog_id = parseInt(e.currentTarget.dataset.dog_id);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Dog details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.value) {
        deleteDogFun(dog_id);
      }
    });
  };
  const editDog = (e) => {
    if (Delete) return;
    const dog_id = e.currentTarget.dataset.dog_id;
    setDogId(dog_id);
    setModal(true);
  };
  return (
    <Card body className="mt-4 dog-list">
      {!Delete && (
        <Link onClick={toggle} color="primary">
          <div className="create-license-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="63"
              height="59"
              viewBox="0 0 63 59"
            >
              <g
                id="Group_115"
                data-name="Group 115"
                transform="translate(0.099)"
              >
                <rect
                  id="Rectangle_1113"
                  data-name="Rectangle 1113"
                  width="59"
                  height="59"
                  rx="29.5"
                  transform="translate(-0.099)"
                  fill="#1b3e6f"
                />
                <path
                  id="Icon_awesome-dog"
                  data-name="Icon awesome-dog"
                  d="M26.905,5.722H23.434l-.388-.776a1.736,1.736,0,0,0-1.552-.96H18.584L17.1,2.506a.868.868,0,0,0-1.482.614v8.128l6.943,2.48V11.8H24.3a3.471,3.471,0,0,0,3.472-3.472V6.59A.868.868,0,0,0,26.905,5.722Zm-6.075,2.6a.868.868,0,1,1,.868-.868A.868.868,0,0,1,20.83,8.325ZM5.207,12.665a1.738,1.738,0,0,1-1.736-1.736,1.736,1.736,0,0,0-3.472,0,5.2,5.2,0,0,0,3.472,4.887v11.6a.868.868,0,0,0,.868.868H7.811a.868.868,0,0,0,.868-.868V21.344h8.679V27.42a.868.868,0,0,0,.868.868H21.7a.868.868,0,0,0,.868-.868V15.57l-8.134-2.9Z"
                  transform="translate(15.896 14.487)"
                  fill="#fff"
                />
                <circle
                  id="Ellipse_19"
                  data-name="Ellipse 19"
                  cx="10"
                  cy="10"
                  r="10"
                  transform="translate(42.901 39)"
                  fill="#dae0e8"
                />
                <path
                  id="Icon_ionic-ios-add"
                  data-name="Icon ionic-ios-add"
                  d="M17.12,12.772H13.855V9.506a.541.541,0,1,0-1.083,0v3.266H9.506a.541.541,0,0,0,0,1.083h3.266V17.12a.541.541,0,1,0,1.083,0V13.855H17.12a.541.541,0,1,0,0-1.083Z"
                  transform="translate(40.068 35.908)"
                  fill="#1b3e6f"
                />
              </g>
            </svg>

            <h4>Add new pet</h4>
          </div>
        </Link>
      )}

      <div className="license-card">
        {details && details.length > 0 ? (
          details.map((record, index) => {
            const {
              dogId,
              dogName,
              breed,
              color,
              sex,
              dogImageUrl,
              dogDescription,
              DOB,
            } = record;
            return (
              <Fragment>
                <Row>
                  <Col md="6" lg="6" xl="6" className="mb-3">
                    <div className="license-box">
                      <div className="dogImg">
                        <img src={dogImageUrl ? dogImageUrl : dogImg} alt=""/>
                      </div>

                      <div className="mt-4">
                        <div>
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Name</h6>
                            </div>
                            <div class="col-auto">
                              <span className="text-sm">{dogName}</span>
                            </div>
                          </div>
                          <hr className="my-2" />
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Breed</h6>
                            </div>
                            <div class="col-auto">
                              <span className="text-sm">{breed}</span>
                            </div>
                          </div>
                          <hr className="my-2" />
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Color</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">{color}</span>
                            </div>
                          </div>
                          <hr className="my-2" />
                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">DOB</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">
                                {moment(DOB).format("MM/DD/YYYY")}
                              </span>
                            </div>
                          </div>
                          <hr className="my-2" />

                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Gender</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">{sex}</span>
                            </div>
                          </div>
                          <hr className="my-2" />

                          <div className="row align-items-center">
                            <div className="col">
                              <h6 className="text-sm mb-0">Description</h6>
                            </div>
                            <div className="col-auto">
                              <span className="text-sm">{dogDescription}</span>
                            </div>
                          </div>
                          <hr className="my-2" />
                        </div>
                      </div>

                      <div className="centerBtn">
                        <Button
                          id="toggler"
                          className="mr-2"
                          color="primary"
                          size="sm"
                          disabled={Delete}
                          data-dog_id={dogId}
                          onClick={editDog}
                        >
                          Edit
                        </Button>
                        <Button
                          id="toggler"
                          color="danger"
                          disabled={Delete}
                          size="sm"
                          data-dog_id={dogId}
                          onClick={deleteDog}
                        >
                          Delete
                          {loading && <CustomButtonLoader />}
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Fragment>
            );
          })
        ) : (
          <CustomTableEmptyRecord />
        )}
      </div>

      {modal && (
        <CreateNewDog
          flag={flag}
          modal={modal}
          toggle={toggle}
          userId={userId}
          selectedDogId={selectedDogId}
          successCallBack={successCallBack}
        />
      )}
    </Card>
  );
}
